<script lang="ts">
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";

  export let backLink: string = null;
  export let backLinkParams: { [key: string]: any } = {};
  export let heading: string;
  export let callbacks: { [key: string]: Function } = null;
  export let rightComponent: string = null;
  export let thisPage: string = null;
  export let rightIcon: string = null;
</script>

<FizzStyles>
  <div
    class="background-white fizz-stack-12 fizz-space-between-responsive fizz-inset-squish-16"
    data-testid="breadcrumb"
  >
    <div class="fizz-flex-row fizz-flex-item fizz-space-between">
      {#if backLink}
        <UIRouterLink stateName={backLink} params={backLinkParams}>
          <Icon type="ArrowLeft" height="12" width="12" />
        </UIRouterLink>
      {/if}
      <h4 class="fizz-heading-4">{heading}</h4>
      {#if { rightIcon }}
        <svelte:component this={rightIcon} {callbacks} />
      {/if}
    </div>
    {#if rightComponent !== null && callbacks !== null}
      <svelte:component this={rightComponent} {callbacks} />
    {:else if rightComponent !== null && callbacks === null}
      <svelte:component this={rightComponent} />
    {:else if thisPage !== null}
      <span>{thisPage}</span>
    {/if}
  </div>
</FizzStyles>
